"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SplitButton: function() {
        return _index.SplitButton;
    },
    renderSplitButton_unstable: function() {
        return _index.renderSplitButton_unstable;
    },
    splitButtonClassNames: function() {
        return _index.splitButtonClassNames;
    },
    useSplitButtonStyles_unstable: function() {
        return _index.useSplitButtonStyles_unstable;
    },
    useSplitButton_unstable: function() {
        return _index.useSplitButton_unstable;
    }
});
const _index = require("./components/SplitButton/index");
